var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRw = function SvgRw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M0 12c0 2.078.529 4.033 1.46 5.738L12 18.782l10.54-1.044C23.472 16.033 24 14.078 24 12l-12-1.043-12 1.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M22.54 6.26A11.997 11.997 0 0 0 12 0 11.997 11.997 0 0 0 0 12h24c0-2.079-.529-4.034-1.46-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M12 24c4.548 0 8.506-2.532 10.54-6.262H1.46A11.997 11.997 0 0 0 11.999 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m13.565 7.022 1.466.69-.78 1.42 1.591-.305.202 1.607 1.108-1.182 1.109 1.182.201-1.607 1.592.304-.78-1.42 1.465-.689-1.466-.689.78-1.42-1.59.305-.203-1.607-1.108 1.182-1.108-1.182-.202 1.607-1.591-.304.78 1.42-1.466.688Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgRw;